import React from "react";

const pluralize = (count, noun, suffix = "s") =>
  `${count} ${noun}${count !== 1 ? suffix : ""}`;

function DocumentPurgeHours({ hours = 72 }) {
  return (
    <em>{`* can only retrieve ${
      hours % 24 === 0 ? pluralize(hours / 24, "day") : pluralize(hours, "hour")
    } past discharge.`}</em>
  );
}

export default DocumentPurgeHours;
